import BaseController from "confinus_ui/base_controller";

export default class DashboardPeriodController extends BaseController {
  select(event: Event) {
    const target = event.currentTarget as HTMLElement;
    const period = target.dataset.period;
    if (!period) return;

    const url = new URL(window.location.href);
    url.searchParams.set("period", period);
    window.location.href = url.toString();
  }
}
